import React from "react";
import { Form, Button } from "semantic-ui-react";
import { useFormik } from "formik";
import { useAuth } from "../../../hook/userAuth";
import { ToastContainer, toast } from "react-toastify";
import { BASE_API } from "../../../ruta-server/BaseApi";
import * as Yup from "yup";
import axios from "axios";

export default function AsigarFechas(props) {
  const { alumno } = props;
  const { auth } = useAuth();

  const updateAlumno = async (alumnoId, data) => {
    try {
      await updateAlumnoApi(alumnoId, data, auth.token);
      return alumnoId; // Devolver el ID del alumno actualizado
    } catch (error) {
      throw error;
    }
  };

  async function updateAlumnoApi(id, data) {
    try {
      const url = `${BASE_API}/api/alumno/${id}/`;
      const headers = {
        Authorization: `Bearer ${auth.token}`,
        "Content-Type": "application/json",
      };
      const response = await axios.patch(url, data, { headers });
      toast.success("Datos actualizados exitosamente");
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  const formik = useFormik({
    initialValues: initialValues(alumno),
    validationSchema: Yup.object(updateSquema()),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        const cleanedFormValue = { ...formValue };
        if (!isValidDate(formik.values.fecha_baja_temporal_1)) {
          cleanedFormValue.fecha_baja_temporal_1 = null;
        }
        if (!isValidDate(formik.values.fecha_baja_temporal_2)) {
          cleanedFormValue.fecha_baja_temporal_2 = null;
        }

        if (alumno) {
          await updateAlumno(alumno.id, cleanedFormValue);
        } else {
          console.log("no encontrado");
        }
        window.location.reload();
      } catch (error) {
        console.error(error);
      }
    },
  });

  const isValidDate = (dateString) => {
    // Use a more robust date validation
    return !isNaN(Date.parse(dateString));
  };

  return (
    <>
      <div className="divcampo">
        <label className="campR">
          Campo requerido <span className="astedisco">*</span>
        </label>
      </div>
      <Form className="add-edit-user-form" onSubmit={formik.handleSubmit}>
        <label>
          Fecha de la baja temporal 1 <span className="astedisco">*</span>
        </label>
        <Form.Input
          name="fecha_baja_temporal_1"
          type="date"
          placeholder="Fecha Baja temporal 1"
          value={formik.values.fecha_baja_temporal_1}
          onChange={formik.handleChange}
          error={formik.errors.fecha_baja_temporal_1}
        />
        <label>
          Fecha de la baja temporal 2 <span className="astedisco">*</span>
        </label>
        <Form.Input
          name="fecha_baja_temporal_2"
          type="date"
          placeholder="Fecha Baja temporal 2"
          value={formik.values.fecha_baja_temporal_2}
          onChange={formik.handleChange}
          error={formik.errors.fecha_baja_temporal_2}
        />

        <Button
          type="submit"
          content={alumno ? "Guardar" : "Crear"}
          className="botonEnviar"
          fluid
        />
      </Form>
      <ToastContainer />
    </>
  );
}

function initialValues(datoAlumno) {
  return {
    fecha_baja_temporal_1: datoAlumno?.fecha_baja_temporal_1 || "",
    fecha_baja_temporal_2: datoAlumno?.fecha_baja_temporal_2 || "",
  };
}

function updateSquema() {
  return {
    fecha_baja_temporal_1: Yup.string().required(true),
  };
}
